import { DEFAULT_THEME } from '../defaults/theme.defaults';
import type { ThemeConfig } from '../models/theme.model';

/** Coerces API/form numeric card dimensions to CSS length strings (e.g. `2` → `2px`). */
export function themeDimensionToPx(
	value: string | number | undefined | null,
	fallback: string
): string {
	if (value === undefined || value === null || value === '') {
		return fallback;
	}
	if (typeof value === 'number' && Number.isFinite(value)) {
		return `${value}px`;
	}
	const trimmed = String(value).trim();
	if (!trimmed) {
		return fallback;
	}
	if (/^\d+(\.\d+)?$/.test(trimmed)) {
		return `${trimmed}px`;
	}
	return trimmed;
}

function cardDimensionsEqual(
	left: ThemeConfig['card'],
	right: ThemeConfig['card']
): boolean {
	return (
		left.borderRadius === right.borderRadius &&
		left.borderWidth === right.borderWidth &&
		left.padding === right.padding &&
		left.spacing === right.spacing
	);
}

/** Normalizes card spacing fields so `border` CSS using custom properties is valid. */
export function normalizeThemeConfigCard(theme: ThemeConfig): ThemeConfig {
	const card = { ...DEFAULT_THEME.card, ...theme.card };
	const normalizedCard = {
		...card,
		borderRadius: themeDimensionToPx(
			card.borderRadius,
			DEFAULT_THEME.card.borderRadius
		),
		borderWidth: themeDimensionToPx(
			card.borderWidth,
			DEFAULT_THEME.card.borderWidth
		),
		padding: themeDimensionToPx(card.padding, DEFAULT_THEME.card.padding),
		spacing: themeDimensionToPx(card.spacing, DEFAULT_THEME.card.spacing),
	};

	if (cardDimensionsEqual(card, normalizedCard) && theme.card) {
		return theme;
	}

	return {
		...theme,
		card: normalizedCard,
	};
}
